<template>
<ion-app>
  <ion-page id="main-content">

  <div id="audio-videos">
    <audio id="myAudio" playsinline src="">
     <!-- <audio id="myAudio" controls src=""> -->
    </audio>
  </div>

  <div v-if="showState == SHOW_START_ASR" :key="showTrigger">
    <StartASRView :startASRStatus="startASRStatus" :startASRStatusTrigger="startASRStatusTrigger"
            @where-next="whereNext"
            ></StartASRView>
  </div>

  <div v-if="showState == SHOW_MAIN" :key="showTrigger">
    <MainMenuView @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext" @attempt-audio-resume="attemptAudioResume"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
                  :welcomeMessage="mainScreenMessage"
                  >
    </MainMenuView>
  </div>
  <div v-if="showState == SHOW_ENGINE_MENU" :key="showTrigger">
    <EngineMenuView @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger">
    </EngineMenuView>
  </div>
  <div v-if="showState == SHOW_VERBAL_PLAY" :key="showTrigger">
    <VerbalPlayView  
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeak"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger">
    </VerbalPlayView>
  </div>
   <div v-if="showState == SHOW_FRIEND_PLAY" :key="showTrigger">
    <FriendPlayView  
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeak"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger">
    </FriendPlayView>
  </div>
  <div v-if="showState == SHOW_GAME_HISTORY" :key="showTrigger">
    <GameHistoryView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
  </GameHistoryView>
  </div>
  <div v-if="showState == SHOW_GAME_REVIEW" :key="showTrigger">
    <GameReviewView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </GameReviewView>
  </div>

  <div v-if="showState == SHOW_ACCOUNT_MENU" :key="showTrigger">
    <AccountMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </AccountMenuView>
  </div>
  <div v-if="showState == SHOW_BOARD_PREFERENCES" :key="showTrigger">
    <BoardPreferencesView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </BoardPreferencesView>
  </div>
  <div v-if="showState == SHOW_VOICES_MENU" :key="showTrigger">
    <VoicesMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </VoicesMenuView>
  </div>
  <div v-if="showState == SHOW_LOG_ON" :key="showTrigger">
    <LoginView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </LoginView>
  </div>
  <div v-if="showState == SHOW_LOG_OFF" :key="showTrigger">
    <LogoffView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </LogoffView>
  </div>
  <div v-if="showState == SHOW_REGISTER" :key="showTrigger">
    <RegisterView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </RegisterView>
  </div>

  <div v-if="showState == SHOW_CANCEL" :key="showTrigger">
    <CancelSubscriptionView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </CancelSubscriptionView>
  </div>

  <div v-if="showState == SHOW_DELETE_ACCOUNT" :key="showTrigger">
    <DeleteAccountView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </DeleteAccountView>
  </div>

   <div v-if="showState == SHOW_EMAIL_VERIFY" :key="showTrigger">
    <EmailVerifyView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
      >
    </EmailVerifyView>
  </div>

  <div v-if="showState == SHOW_SELECT_VOICES" :key="showTrigger">
    <SelectVoicesView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeakFromSelectVoice"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SelectVoicesView>
  </div>
  <div v-if="showState == SHOW_SELECT_LANGUAGE" :key="showTrigger">
    <SelectLanguageView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SelectLanguageView>
  </div>

  <div v-if="showState == SHOW_RECOGNIZER_DEMO" :key="showTrigger">
    <RecognizerDemoView
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </RecognizerDemoView>
  </div>
  <div v-if="showState == SHOW_LICHESS_MENU" :key="showTrigger">
    <LichessMenuView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessMenuView>
  </div>
  <div v-if="showState == SHOW_LICHESS_CHALLENGE" :key="showTrigger">
    <LichessChallengeView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessChallengeView>
  </div>
  <div v-if="showState == SHOW_LICHESS_FRIENDS" :key="showTrigger">
    <LichessFriendView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessFriendView>
  </div>
   <div v-if="showState == SHOW_LICHESS_ARENA" :key="showTrigger">
    <LichessArenaView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessArenaView>
  </div>
   <div v-if="showState == SHOW_LICHESS_OPEN_GAMES" :key="showTrigger">
    <LichessOpenView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessOpenView>
  </div>
  <div v-if="showState == SHOW_LICHESS_PLAY" :key="showTrigger">
    <LichessPlayView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  @string-to-speak="stringToSpeak"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessPlayView>
  </div>
  <div v-if="showState == SHOW_LICHESS_CONNECT" :key="showTrigger">
    <LichessConnectView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </LichessConnectView>
  </div>
  <div v-if="showState == SHOW_SUBSCRIBE" :key="showTrigger">
    <SubscribeBlurbView 
                  @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </SubscribeBlurbView>
  </div>
  <div v-if="showState == SHOW_LANDING_PAGE" :key="showTrigger">
    <DisplayLandingPageView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </DisplayLandingPageView>
  </div>
  <div v-if="showState == SHOW_PASSWORD_RESET" :key="showTrigger">
    <PasswordResetView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </PasswordResetView>
  </div>
  <div v-if="showState == SHOW_NEW_LANDING_PAGE || showState == SHOW_NEW_LANDING_PAGE_FROM_MAIN" :key="showTrigger">
    <NewLandingPageView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :fromMainPage="showState == SHOW_NEW_LANDING_PAGE_FROM_MAIN"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </NewLandingPageView>
  </div>
  <div v-if="showState == SHOW_EMAIL_VERIFIED" :key="showTrigger">
    <EmailVerifiedView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </EmailVerifiedView>
  </div>
  <div v-if="showState == SHOW_STRIPE_CANCEL" :key="showTrigger">
    <StripeCancelView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </StripeCancelView>
  </div>
  <div v-if="showState == SHOW_STRIPE_ACCOUNT" :key="showTrigger">
    <StripeAccountView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </StripeAccountView>
  </div>
  <div v-if="showState == SHOW_STRIPE_SUCCESS" :key="showTrigger">
    <StripeSuccessView
     @word-list="newWordList"  @mic-is-muted="setMicrophoneIsMuted" 
                  @where-next="whereNext"
                  :wordsSaid="wordsSaid" :wordsSaidTrigger="wordsSaidTrigger"
    >
    </StripeSuccessView>
  </div>
  </ion-page>
  </ion-app>
</template>

// https://stackoverflow.com/questions/61396466/how-to-disable-a-vuejs-router-link

<script setup>

  import { setInterval, setTimeout, clearInterval, clearTimeout } from 'requestanimationframe-timer';
  import { useGetData, generateErrorAlertText } from '@/composables/getData.js'

    import { IonApp, IonRouterOutlet , IonPage, menuController } from '@ionic/vue';

  import { getPlatforms } from '@ionic/vue';

  import TopLine from '@/components/TopLine.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { ref, watch, onMounted, onUnmounted , onBeforeUnmount } from 'vue'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { usePwaStore } from '@/stores/pwaStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { translateEnglishWords, translateForeignWords, setTranslationLanguage, translatePhrase } from '@/composables/translation';
  import { getCompleteWordlist } from "@/composables/translationText";

  import MainMenuView from '@/views/MainMenuView.vue';
  import EngineMenuView from '@/views/Engines/EngineMenuView.vue';
  import VerbalPlayView from '@/views/Engines/VerbalPlayView.vue';
  import FriendPlayView from '@/views/Engines/FriendPlayView.vue';
  import GameHistoryView from '@/views/Engines/GameHistoryView.vue';
  import GameReviewView from '@/views/Engines/GameReviewView.vue';
  import AccountMenuView from '@/views/Account/AccountMenuView.vue';
  import LichessMenuView from '@/views/Lichess/LichessMenuView.vue';
  import LichessChallengeView from '@/views/Lichess/LichessChallengeView.vue';
  import LichessFriendView from '@/views/Lichess/LichessFriendView.vue';
  import LichessArenaView from '@/views/Lichess/LichessArenaView.vue';
  import LichessOpenView from '@/views/Lichess/LichessOpenView.vue';
  import LichessPlayView from '@/views/Lichess/LichessPlayView.vue';
  import LichessConnectView from '@/views/Lichess/LichessConnectView.vue';

  import LoginView from '@/views/Account/LoginView.vue';
  import LogoffView from '@/views/Account/LogoffView.vue';
  import RegisterView from '@/views/Account/RegisterView.vue';
  import SelectVoicesView from '@/views/Account/SelectVoicesView.vue';
  import VoicesMenuView from '@/views/Account/VoicesMenuView.vue';
  import SelectLanguageView from '@/views/Account/SelectLanguageView.vue';
  import SubscribeBlurbView from '@/views/SubscribeBlurbView.vue';
  import StartASRView from '@/views/StartASRView.vue';
  import DisplayLandingPageView from '@/views/DisplayLandingPageView.vue';
  import NewLandingPageView from '@/views/NewLandingPageView.vue';

  import PasswordResetView from '@/views/Urlactions/PasswordResetView.vue';

  import {  Recognizer } from "vosk-browser"

  import BoardPreferencesView from '@/views/Account/BoardPreferencesView.vue';
  import EmailVerifiedView from '@/views/Urlactions/EmailVerifiedView.vue';
  import StripeCancelView from '@/views/Urlactions/StripeCancelView.vue';
  import StripeSuccessView from '@/views/Urlactions/StripeSuccessView.vue';
  import RecognizerDemoView from '@/views/Account/RecognizerDemoView.vue';

  import { verifyMp3NameLanguage } from '@/composables/mp3Support.js'
  import CancelSubscriptionView from '@/views/Account/CancelSubscriptionView.vue';
  import DeleteAccountView from '@/views/Account/DeleteAccountView.vue';
  import StripeAccountView from '@/views/Urlactions/StripeAccountView.vue';
  import EmailVerifyView from '@/views/Account/EmailVerifyView.vue';

  var canChangeSize = true

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()
  const pwaStore = usePwaStore();

  // language. if user selected "system" -- empty, then grab the default -- unless not supported
  var languageInUse = connectionStore.getLanguageIncludingSystem
  //languageInUse = "en"
  console.log("system lanaguage",languageInUse)
  if (languageInUse == "") {
    const userPreferredLanguage = navigator.language;
    const language2char = userPreferredLanguage.slice(0, 2)
    const systemLanguage = (language2char != "en" && language2char != "es" &&
                            language2char != "it" && language2char != "de" &&
                            language2char != "fr" && language2char != "pt") 
                            ? "en" : language2char
    languageInUse = systemLanguage
  }
  console.log("******* language in use",languageInUse)
  connectionStore.setLanguageInUse(languageInUse)
  setTranslationLanguage(languageInUse)

  // check the voice and language for MP3
  verifyMp3NameLanguage(languageInUse)

  determineDeviceType()

  // force startup info read on program restart
  connectionStore.setLastStartupDate("0")
  
  const windowSizeRef = ref({})
  windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)

  const wordsSaid = ref("")
  const wordsSaidTrigger = ref(0)

  // speaking
  var voices = []
  var engineVoiceNumber = -1
  var playerVoiceNumber = -1

  const processWindowSizeChange = debounce(() => windowSizeChange(),250)
  const processVisualPortSizeChange = debounce(() => windowSizeChange(),250)

  const showTrigger = ref(0)

  const SHOW_START_ASR = 99

  const SHOW_MAIN = 0
  const SHOW_ENGINE_MENU = 1
  const SHOW_VERBAL_PLAY = 2
  const SHOW_FRIEND_PLAY = 3
  const SHOW_GAME_HISTORY = 4
  const SHOW_GAME_REVIEW = 5

  const SHOW_ACCOUNT_MENU = 10
  const SHOW_SELECT_VOICES = 11
  const SHOW_LOG_ON = 12
  const SHOW_REGISTER = 13
  const SHOW_LOG_OFF = 14
  const SHOW_BOARD_PREFERENCES = 15
  const SHOW_VOICES_MENU = 16
  const SHOW_SELECT_LANGUAGE = 17
  const SHOW_RECOGNIZER_DEMO = 18
  const SHOW_CANCEL = 19
  const SHOW_DELETE_ACCOUNT = 20
  const SHOW_EMAIL_VERIFY = 21

  const SHOW_SUBSCRIBE = 30
  const SHOW_LANDING_PAGE = 31
  const SHOW_NEW_LANDING_PAGE = 32
  const SHOW_NEW_LANDING_PAGE_FROM_MAIN = 33

  const SHOW_PASSWORD_RESET = 40
  const SHOW_STRIPE_CANCEL = 41
  const SHOW_STRIPE_SUCCESS = 42
  const SHOW_EMAIL_VERIFIED = 43
  const SHOW_STRIPE_ACCOUNT = 44

  const SHOW_LICHESS_MENU = 50
  const SHOW_LICHESS_CHALLENGE = 51
  const SHOW_LICHESS_FRIENDS = 52
  const SHOW_LICHESS_ARENA = 53
  const SHOW_LICHESS_OPEN_GAMES = 54
  const SHOW_LICHESS_PLAY = 55
  const SHOW_LICHESS_CONNECT = 56

  const showState = ref(SHOW_START_ASR)

  const currentUrl = window.location.href;
  //console.log("**** CURRENT URL ",currentUrl)
   const urlParams =  new URLSearchParams(window.location.search)
  //console.log("***** URL Parameters",urlParams)

  var urlAction = null
  // testing
  //urlAction = "stripe_cancel"
  //urlAction = "stripe_success"
  //urlAction = "passwordreset"
  //urlAction = "emailverified"
  // localStorage.setItem("url_v","NzY2NTcyNjk2Njc5MjAyMA--OGZjMWI0NGMwNzFkMjE0ZDZkMmQ5M2Q1YWQ3MzQ1MWIxZTMxZTg4ZQ--")
  // localStorage.setItem("url_e","henry@conceptual.com")

  //localStorage.setItem("url_v","NzY2NTcyNjk2Njc5MjAyMA--ZWIyZDY1NTdlNzU4MzYyOTdjODg3OTkyZGI4N2I0YTViYmM4NTlmNQ--")
  //localStorage.setItem("url_e","henry%40conceptual.com")

  if (urlParams.size > 0) {
    var parametersToDelete = []
    for (const [key, value] of urlParams.entries()) {
      parametersToDelete.push(key)
      if (key == "a")
        urlAction = value
      localStorage.setItem("url_" + key,value)
    }
    // clear the browser line
    const subdir = (import.meta.env.MODE === 'production') ? "/" : "/"
    history.replaceState(null, "", subdir);
  }
  else {
    // no url options
    localStorage.setItem("url_a","")
  }

  // start the ball rolling to get the MP3
  getWelcomeMp3()

  const startASRStatus = ref("start")
  const startASRStatusTrigger = ref(0)

  // show login, register message when coming back to main screen
  const mainScreenMessage = ref("")

  var recognizer = null
  const sampleRate = 48000;
  var mediaStream = null
  var channel = null
  var audioContext = null
  var microphoneIsMuted = false
  const currentWordlist = ref("")
  var voskModel = null
  var isInitialized = false  // ← add this flag

  console.log("show state here",showState.value)

  function sendReady() {
    //console.log("send ready with delay");
    startASRStatus.value = "ready"
    startASRStatusTrigger.value++
  }

  // **** START Computer Speaking Routines

  function setMicrophoneState(muteMicrophone) {
    //console.log("stream set",muteMicrophone,mediaStream)
    if (mediaStream == null)
      return
    const audioTracks = mediaStream.getAudioTracks();
    audioTracks.forEach(function(track) {
        track.enabled = !muteMicrophone
    });
    //console.log("*** microphone mute state", muteMicrophone)
  }

  var whatToSayStack = []

  function audioStartedPlaying(event) {
    //console.log("AUDIO STARTED")
    setMicrophoneState(true)
  }
  
  function audioError(event) {
    console.log("AUDIO ERROR",event)
    audioEnded(event)
  }

  function audioEnded(event) {
    //console.log("*********************************. AUDIO ENDED")
    const justPlayed = whatToSayStack.shift()
    if (whatToSayStack.length >= 1)
      speakFirstElementInStack()
    else
      setMicrophoneState(false)
  }

  function attemptAudioResume() {
    console.log("***************************** in attempt audio resume")
    audioContext.resume().then(() => {
      console.log("********************************** attempt to resume",audioContext.state)
    });
  }

  function speakFirstElementInStack() {
    const location = whatToSayStack[0]

    // audioContext.resume().then(() => {
    //   console.log("attempt to resume",audioContext.state)
    // });

    var audioPlayer = document.getElementById('myAudio');
    audioPlayer.src = location;
    audioPlayer.onplaying = audioStartedPlaying
    audioPlayer.onended = audioEnded
    audioPlayer.onerror = audioError
    audioPlayer.play(); // Play the new audio file

  /*
    var audio = new Audio(location);
    if (audio != null) {
      audio.onplaying = audioStartedPlaying
      audio.onended = audioEnded
      audio.onerror = audioError
      audio.play()
    }
    else {
      console.log("AUDIO NULL")
      setMicrophoneState(false)
    }
      */
  }

  function processMp3JsonResponse (json) {
    //console.log(" mp3 callback",json)

    if (json.hasOwnProperty('error')) {
      console.log("*********************** MP3 ERROR ***************",json)
      return;
    }

    const urlBase = "https://www.verbalchess.fun/"
    const directory = json['dir']
    const locations = json['locations'].split("\t")

    for (var i=0; i < locations.length; i++) {
      const url =  urlBase + directory + locations[i]
      whatToSayStack.push(url)
    }
    if (whatToSayStack.length == locations.length)
      speakFirstElementInStack()
  }

  // https://developer.mozilla.org/en-US/docs/Web/Media/Guides/Autoplay

  // get the mp3 mode
  function getMp3(usePlayerVoice,whatToSay) {

    const connectionStore = useConnectionStore()

    var formData = {
      vendor : (usePlayerVoice) ? connectionStore.getPlayerMp3Vendor : connectionStore.getOpponentMp3Vendor ,
      voice : (usePlayerVoice) ? connectionStore.getPlayerMp3Name : connectionStore.getOpponentMp3Name ,
      language : (usePlayerVoice) ? connectionStore.getPlayerMp3Lang : connectionStore.getOpponentMp3Lang ,
      text : whatToSay
    }
    
    //console.log("**************** get mp3 formdata",formData)
    useGetData("get_mp3_tab.php", formData,processMp3JsonResponse)
  }

  function voiceAddMicrophoneSupport(msg) {
    //console.log("in voice add microphone")
    msg.onstart = () => { 
      //console.log('Speech started');
      setMicrophoneState(true)
    }
    msg.onend = () => {
        //console.log('Speech ended');
        setMicrophoneState(false)
    }
    msg.onerror = (event) => {
      console.error('Speech error:', event.error);
      setMicrophoneState(false)
    }
    msg.onpause = () => {
      //console.log('Speech paused');
      setMicrophoneState(false)
    }
    msg.onresume = () => {
      //console.log('Speech resumed');
      setMicrophoneState(false)
    }
  }

  // used by select voice to play voice without it being assigned to player or opponent
  function stringToSpeakFromSelectVoice(whatToSay,lang,name,vendor) {

    var formData = {
      vendor : vendor,
      voice : name ,
      language : lang ,
      text : whatToSay
    }
    
    //console.log("**************** get mp3 formdata",formData)
    useGetData("get_mp3_tab.php", formData,processMp3JsonResponse)
  }

  function stringToSpeak(usePlayerVoice,whatToSay) {
    console.log("********** STRING",usePlayerVoice,whatToSay,audioContext.state)

    audioContext.resume().then(() => {
      console.log("***************************attempt to resume in string to speak",audioContext.state)
    });

    getMp3(usePlayerVoice,whatToSay)
   
  }

  // **** END Computer Speaking Routines

  async function initAudioContext(firstCall) {
   
      console.log("****************************** init audio context",firstCall,audioContext.state)

      await audioContext.audioWorklet.addModule('recognizer-processor.js')

      console.log("after add module")
      const recognizerProcessor = new AudioWorkletNode(
        audioContext, 
        'recognizer-processor', 
        { channelCount: 1, numberOfInputs: 1, numberOfOutputs: 1 });

      console.log("after new audioworkletnode")

      recognizerProcessor.port.postMessage(
       {action: 'init', recognizerId: recognizer.id}, [ channel.port2 ])

      console.log("after postmessage")

      recognizerProcessor.connect(audioContext.destination);

      console.log("after connect")

      const source = audioContext.createMediaStreamSource(mediaStream);
      source.connect(recognizerProcessor);

      console.log("AudioContext Sample Rate:", audioContext.sampleRate);

      startASRStatus.value = "audioDone"
      startASRStatusTrigger.value++

      console.log("Audio Done")
  }

  // taken from the chessvis code for voice within the learn with coach

  const getAudioPermissions = async () => {

    const constraints = { video: false, 
      audio: {
        echoCancellation: true,  // prevent app's own audio being re-heard as commands
        //noiseSuppression: true,  // cleaner mic in noisy environments
      }
    }

    if (navigator == null) {
      //alert("No Navigator")
      alert(translatePhrase('Your browser does not support getUserMedia API'));
      initVosk()
      return
    }
    if (navigator.mediaDevices == null) {
      //alert("No mediaDevices")
      alert(translatePhrase('Your browser does not support getUserMedia API'));
      initVosk()
      return
    }
    if (!navigator.mediaDevices.getUserMedia) {
      alert(translatePhrase('Your browser does not support getUserMedia API'));
      initVosk()
      return;
    }

    try {
      // Claude suggestion to force use of main speaker
      // Hint the audio session type before requesting the stream
      if ('audioSession' in navigator) {
        try {
          navigator.audioSession.type = 'play-and-record'
        } catch (e) {
          console.log('audioSession type not supported:', e)
        }
      }
      mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    } catch(error) {
        alert(translatePhrase('Your browser has blocked Verbal Chess from using the microphone'));
        initVosk()
        return
    }

    console.log("END OF getAudioPermissions")
    initVosk()
  }

  async function initVosk() {
      
    var modelName = ""

    console.log("******************************* in init VOSK")

    channel = new MessageChannel();

    startASRStatus.value = "downloading"
    startASRStatusTrigger.value++

    // define where the program should be stored
    modelName = (connectionStore.getUseVerbalWebsite) ? 
                            "https://www.verbalchess.fun/" :
                            "https://www.chessvis.com/verbal2/"         
               
    modelName = "/"

    switch (languageInUse) {
      case "de" :
        modelName += "vosk-model-small-de-0.15.zip"
        break
      case "fr" :
        modelName += "vosk-model-small-fr-0.22.zip"
        break
      case "it" :
        modelName += "vosk-model-small-it-0.22.zip"
        break
      case "es" :
        modelName += "vosk-model-small-es-0.42.zip"
        break
      case "pt" :
        modelName += "vosk-model-small-pt-0.3.zip"
        break
      default :
        modelName += "model.tar.gz"
        break
    }

    console.log("create model",modelName)
    
    voskModel = await Vosk.createModel(modelName);

    voskModel.registerPort(channel.port1);

    recognizer = new voskModel.KaldiRecognizer(sampleRate,JSON.stringify(["",'[unk]']));

    //recognizer = new model.KaldiRecognizer(sampleRate,JSON.stringify(["cat dog rabbit",'[unk]']));
    //recognizer.setGrammar(JSON.stringify(["apple pear peach",'[unk]']),sampleRate)

    // if in development, feed complete list in at beginning
    if (import.meta.env.MODE !== 'production') {
      const completeWordList = getCompleteWordlist()
      newWordList(completeWordList)
    }
    
    recognizer.setWords(true);

    recognizer.on("result", (message) => {
        handleResult(message)
    });
    // recognizer.on("partialresult", (message) => {
    //     const partial = message.result.partial;
    //      console.log("*** PARTIAL ",partial)
    // });
    
    startASRStatus.value = "downloaded"
    startASRStatusTrigger.value++

    console.log("**** READY !")
    
    try {

      console.log("before getTracks media devices")
      const audioTracks = mediaStream.getTracks().find(track => track.kind === 'audio')

      console.log("audio tracks",audioTracks)
      const audioTrack = mediaStream.getAudioTracks()[0];
      console.log("audio track zero ",audioTrack)
      const trackSettings = audioTrack.getSettings();
      console.log("track settings",trackSettings)
      const sampleRate = trackSettings.sampleRate;
      console.log("Audio Sample Rate:", sampleRate);

      // You can also use the AudioContext's sampleRate if you're processing the audio
      // const audioContext = new AudioContext();
      // const source = audioContext.createMediaStreamSource(stream);
      // console.log("AudioContext Sample Rate:", audioContext.sampleRate);
    
      // trying the simpler approach above.
      // mediaStream = await navigator.mediaDevices.getUserMedia({
      //     video: false,
      //     audio: {
      //         echoCancellation: true,
      //         noiseSuppression: true,
      //         channelCount: 1,
      //         sampleRate
      //     },
      // });
    }
    catch (e) {
      console.log("ERROR ",e)
    }

    if (mediaStream != null) {
      startASRStatus.value = "mic"
      startASRStatusTrigger.value++
      const timeoutId = setTimeout(sendReady, 200);
    }
    else {
      startASRStatus.value = "no_mic"
      startASRStatusTrigger.value++
      console.log("no media stream")
    }

    //showState.value = SHOW_MAIN
    isInitialized = true  // ← set at the very end

  }

  function createAudioContext() {
    console.log("in create audio context")
    audioContext = new AudioContext();
    audioContext.onerror = function(event) {
      console.error("*************** AudioContext error:", event);    
      alert(translatePhrase("Audio Context error. If you're using the 'Chrome' browser on Android, please try another browser. 'Verbal Chess' won't respond to voice commands but you can still tap and click"))
      startASRStatus.value = "audioDone"
      startASRStatusTrigger.value++
      // Implement error handling or recovery logic here
    };
    console.log("audio context",audioContext)
  }

  function startAudioContext() {
    console.log("Start Audio Context")
    initAudioContext(true)
  }

  function newWordList(wordList) {

    // save the word list if need to restart
    currentWordlist.value = wordList
    console.log("***************************  new word list",wordList)
    const translatedWordlist = translateEnglishWords(wordList,true)
    console.log("***************************  translated new word list",translatedWordlist)
    if (recognizer != null)
      recognizer.setGrammar(JSON.stringify([translatedWordlist,'[unk]']),sampleRate)
    console.log("***************************  set Grammar")
  }

  function setMicrophoneIsMuted(isMuted) {
    console.log("************** set microphone status",isMuted)
    microphoneIsMuted = isMuted
  }

  // from Claude to stop/restart vosk

  async function resetAudioContext() {
    try {
      console.log("******************************* reset audio context", audioContext.state)

      // Always get a fresh stream — the old one may have been killed by the OS
      if (mediaStream) {
        mediaStream.getTracks().forEach(track => track.stop())
      }
      mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true })

      if (!mediaStream || !(mediaStream instanceof MediaStream) || !mediaStream.active) {
        console.warn('resetAudioContext: invalid stream, aborting')
        return
      }

      await audioContext.audioWorklet.addModule('recognizer-processor.js')
      console.log("after add module")

      const recognizerProcessor = new AudioWorkletNode(
        audioContext,
        'recognizer-processor',
        { channelCount: 1, numberOfInputs: 1, numberOfOutputs: 1 })

      console.log("after new audioworkletnode")

      channel = new MessageChannel()
      voskModel.registerPort(channel.port1)

      recognizerProcessor.port.postMessage(
        { action: 'init', recognizerId: recognizer.id }, [channel.port2]
      )

      console.log("after postmessage")

      recognizerProcessor.connect(audioContext.destination)
      console.log("after connect")

      const source = audioContext.createMediaStreamSource(mediaStream)
      source.connect(recognizerProcessor)

      console.log("AudioContext Sample Rate:", audioContext.sampleRate)

      startASRStatus.value = "audioDone"
      startASRStatusTrigger.value++
      console.log("Audio Done")

    } catch (err) {
      console.warn('resetAudioContext failed:', err)
      startASRStatus.value = "audioError"
      startASRStatusTrigger.value++
    }
  }

  function handleResult(message) {
        const result = message.result;
        console.log(JSON.stringify(result, null, 2));
        const textNative = result['text']
        if (textNative == "")
          return
        console.log("TEXT NATIVE",textNative)

        // code to dump the heard speech just above the toolbar
        // const element = document.getElementById("speech_text")
        // if (element != null)
        //   element.textContent = textNative

        const text = translateForeignWords(textNative)
        console.log("*** RESULT ",text,showState.value)

        if (microphoneIsMuted) {
          if (text == "command listen") {
              wordsSaid.value = (showState.value == SHOW_RECOGNIZER_DEMO) ? 
                          text + "," + textNative : text
              wordsSaidTrigger.value++
          }
        }   
        else
          if (text != "" && text != "[unk]") {
                  //console.log("**********************.  result",text)
                  wordsSaid.value = (showState.value == SHOW_RECOGNIZER_DEMO) ? 
                          text + "," + textNative : text
                  wordsSaidTrigger.value++
                  //console.log("text sent back",wordsSaid.value)
          }
    }

  async function restartVosk() {
    console.log("********************************** Restarting VOSK")
    //speak('restarting')
    
    // Get new mic stream
    try {

      // Claude suggestion to force use of main speaker
      // Hint the audio session type before requesting the stream
      if ('audioSession' in navigator) {
        try {
          navigator.audioSession.type = 'play-and-record'
        } catch (e) {
          console.log('audioSession type not supported:', e)
        }
      }

      console.log('--- requesting getUserMedia')
      mediaStream = await navigator.mediaDevices.getUserMedia({ 
        video: false, audio: true 
      })
      console.log('--- got stream:', mediaStream)
      console.log('--- tracks:', mediaStream.getTracks())
      console.log('--- audio tracks:', mediaStream.getAudioTracks())
      console.log('--- track state:', mediaStream.getAudioTracks()[0]?.readyState)
    } catch(e) {
      console.error('--- getUserMedia failed:', e.name, e.message)
    }

    console.log('AudioContext state before resume:', audioContext?.state)
    await audioContext?.resume()
    console.log('AudioContext state after resume:', audioContext?.state)

    // Recreate recognizer from existing model (fast - no download)
    recognizer = new voskModel.KaldiRecognizer(sampleRate, JSON.stringify(["",'[unk]']))
    recognizer.setWords(true)
    
    // Rewire the result handler
    recognizer.on("result", handleResult)  // extract your result handler
    
    // Reconnect audio graph with new mediaStream ← the missing piece
    await resetAudioContext()

    // Restore current wordlist
    newWordList(currentWordlist.value)
    
    //speak('ready')
    console.log("ready")
  }

  function stopVosk() {
    // Stop mic tracks - releases microphone
    mediaStream?.getTracks().forEach(track => track.stop())
    mediaStream = null
    
    // Suspend audio context - pauses processing
    audioContext?.suspend()
    
    // Free recognizer - but keep model
    //recognizer?.free()
    recognizer = null
  }

  window.onerror = function(message, source, lineno, colno, error) {
    // Handle the error here
    // Returning true prevents the default browser error message (in older browsers)
    //console.log("got window ONERROR", message)

    return false; 
  };

  // window.addEventListener('error', e => {

  //   // Get the error properties from the error event object
  //   const { message, filename, lineno, colno, error } = e; 
  //   console.log("got window error", message)
  // });

  function whereNext(destination) {
    //console.log("******* Destination ",destination)
    switch (destination) {
      case "initAudio" :
        startAudioContext();
        break
      case "/main_from_login" :
        mainScreenMessage.value = "login"
        showState.value = SHOW_MAIN
        break
      case "/main_from_register" :
        mainScreenMessage.value = "register"
        showState.value = SHOW_MAIN
        break
      case "/" :
        mainScreenMessage.value = ""
        showState.value = SHOW_MAIN
        break
      case "/main_or_urlaction" :
        // ASR is up, was there an action on the URL?  (This is used first time through)
        console.log("*** ASR is done ****")
        mainScreenMessage.value = ""
        if (urlAction == null) {
          showState.value = SHOW_MAIN
          break
        }
        switch (urlAction) {
          case "stripe_cancel" :
            showState.value = SHOW_STRIPE_CANCEL
            break
          case "stripe_success" :
            showState.value = SHOW_STRIPE_SUCCESS
            break
          case "stripe_account" :
            showState.value = SHOW_STRIPE_ACCOUNT
            break

          // need to keep these for the native versions to reset password and verify email
          case "emailverified" :
            showState.value = SHOW_EMAIL_VERIFIED
            break
          case "passwordreset" :
            showState.value = SHOW_PASSWORD_RESET
            break

          default :     // landing, play, android or ios is okay to go to main
            showState.value = SHOW_MAIN
            break
        }
        break
      case "/enginemenu" :
        showState.value = SHOW_ENGINE_MENU
        break
      case "/verbalplay" :
        showState.value = SHOW_VERBAL_PLAY
        break
      case "/friendplay" :
        showState.value = SHOW_FRIEND_PLAY
        break
      case "/gamehistory" :
        showState.value = SHOW_GAME_HISTORY
        break
      case "/gamereview" :
        showState.value = SHOW_GAME_REVIEW
        break
      case "/accountmenu" :
        showState.value = SHOW_ACCOUNT_MENU
        break
      case "/boardpreferences" :
        showState.value = SHOW_BOARD_PREFERENCES
        break
      case "/voicesmenu" :
        showState.value = SHOW_VOICES_MENU
        break
      case "/selectlanguage" :
        showState.value = SHOW_SELECT_LANGUAGE
        break
      case "/recognizerdemo" :
        showState.value = SHOW_RECOGNIZER_DEMO
        break
      case "/login" :
        showState.value = SHOW_LOG_ON
        break
      case "/logoff" :
        showState.value = SHOW_LOG_OFF
        break
      case "/register" :
        showState.value = SHOW_REGISTER
        break
      case "/selectvoices" :
        showState.value = SHOW_SELECT_VOICES
        break
      case "/cancel" :
        showState.value = SHOW_CANCEL
        break
      case "/delete_account" :
        showState.value = SHOW_DELETE_ACCOUNT
        break
      case "/email_verify" :
        showState.value = SHOW_EMAIL_VERIFY
        break

      case "/restartasr" :

        //location.href = currentUrl
        
        // if from Android then need to have it request the load again 
        const url_a = localStorage.getItem("url_a")
        const isAndroid = url_a != null && url_a == "android" && typeof(Android) != "undefined"
        if (isAndroid)
            Android.AndroidMessage("RELOAD","")
        else
          location.reload();
        break
      case "/lichessmenu" :
        showState.value = SHOW_LICHESS_MENU
        break
      case "/lichessconnect" :
        showState.value = SHOW_LICHESS_CONNECT
        break
      case "/lichesschallenge" :
        showState.value = SHOW_LICHESS_CHALLENGE
        break
      case "/lichessarena" :
        showState.value = SHOW_LICHESS_ARENA
        break
      case "/lichessfriends" :
        showState.value = SHOW_LICHESS_FRIENDS
        break
      case "/lichessopen" :
        showState.value = SHOW_LICHESS_OPEN_GAMES
        break
      case "/lichessplay" :
        showState.value = SHOW_LICHESS_PLAY
        break

      case "/subscribe" :
        showState.value = SHOW_SUBSCRIBE
        break
      case "/landingpage" :
        //console.log("show landing page")
        showState.value = SHOW_NEW_LANDING_PAGE_FROM_MAIN
        break
      default :
        console.log("******************** unknown route -> ",destination)
        break
    }
    showTrigger.value++
  }
  
  // save the URL so it is ready to use
  function processWelcomeMp3JsonResponse(json) {
    console.log(" mp3 callback in main",json)

    const urlBase = "https://www.verbalchess.fun/"
    const directory = json['dir']
    const locations = json['locations'].split("\t")
    const url =  urlBase + directory + locations[0]

    console.log("!!!!!!!!!!!!!!!!!!!!!!!!! URL for Welcome MP3",url)

  }

  // get the MP3 URL so when IOS user clicks button, it is ready to play
  function getWelcomeMp3() {

    var url_a = localStorage.getItem("url_a")
    const isUrlFromAndroid = url_a != null && url_a == "android" && typeof(Android) != "undefined"
    const isUrlFromIOS = url_a != null && url_a == "ios"

    var formData = {
      vendor : connectionStore.getPlayerMp3Vendor ,
      voice : connectionStore.getPlayerMp3Name ,
      language : connectionStore.getPlayerMp3Lang  ,
      text : (isUrlFromIOS || isUrlFromIOS) ? translatePhrase("Verbal Chess Web Edition") 
                      : translatePhrase("Welcome to Verbal Chess")
    }
    
    //console.log("**************** get mp3 formdata",formData)
    useGetData("get_mp3_tab.php", formData,processWelcomeMp3JsonResponse)
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("new window size",windowSizeRef.value)
  })
  
  function debounce(callback, interval=500) {
    let debounceTimeoutId;

    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }

   function windowSizeChange() {
     //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
     windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  function determineDeviceType() {
    // https://capacitorjs.com/docs/core-apis/web#isnativeplatform
    const platformList = getPlatforms()
    const platformListString = platformList.join(",")
    
    //alert("Platforms " + platformListString)

    // don't let mobile devices resize but let them change orientation
    canChangeSize = !platformListString.includes("mobile")

    if (platformListString.includes("ios"))
      connectionStore.setDeviceType("ios")
    else
    if (platformListString.includes("android"))
      connectionStore.setDeviceType("android")
    else
      connectionStore.setDeviceType("web")
  }

  const onOrientationChange = () => {
    const deviceType = connectionStore.getDeviceType
    //console.log("**** on orientation change",deviceType)
    if (!canChangeSize)
      processWindowSizeChange()

    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  const onResizeChange = () => {
    //windowWidth.value = window.innerWidth
    //windowHeight.value = window.innerHeight
    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)

    /*
    var windowSizeObject = {
      w: window.outerWidth,
      h: window.outerHeight,
      iw: window.innerWidth,
      ih: window.innerHeight
    };
    //console.log("window size", windowSizeObject)
    */
   
     if (canChangeSize)
      processWindowSizeChange()
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  const onVisualViewportChange = () => {
    //console.log("**** visual viewport change")
    //console.log("**** height changed in app ",window.innerHeight,window.innerWidth)
    if (canChangeSize)
      processVisualPortSizeChange()
    //windowSizeStore.updateStoredWindowSize(window.innerWidth,window.innerHeight)
  }

  // var hasPlayed = false;
  // function handleFirstPlay(event) {
  //   if (!hasPlayed) {
  //     console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ FIRST PLAY @@@@@@@@@@@@@@@@@@")
  //     hasPlayed = true;

  //     // Remove listener so this only gets called once.
  //     const aud = event.target;
  //     aud.removeEventListener("play", handleFirstPlay);

  //     // Start whatever you need to do after first playback has started
  //   }
  // }

  //https://web.dev/blog/screen-wake-lock-supported-in-all-browsers

  // The wake lock sentinel.
  let wakeLock = null;

  // Function that attempts to request a screen wake lock.
  const requestWakeLock = async () => {
    try {
      wakeLock = await navigator.wakeLock.request();
      wakeLock.addEventListener('release', () => {
        console.log('Screen Wake Lock released:', wakeLock.released);
      });
      console.log('Screen Wake Lock released:', wakeLock.released);
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  };

  onMounted(() => {
    
    document.addEventListener('visibilitychange', async () => {
      if (!isInitialized) 
        return  // ← skip if first init hasn't completed yet

      if (document.visibilityState === 'hidden') {
        console.log('--- HIDDEN: stopping VOSK')
        stopVosk()
      } else {
        console.log('--- VISIBLE: restarting VOSK')
        await restartVosk()
      }
    })

    // Request a screen wake lock…
    requestWakeLock(); 

    // const audio = document.getElementById("myAudio");
    // audio.addEventListener("play", handleFirstPlay);

    //console.log("before onresize add")
    window.addEventListener('resize', onResizeChange)
    window.addEventListener('orientationchange', onOrientationChange)
    visualViewport.addEventListener('resize', onVisualViewportChange)

    //console.log("after add event")
    var element = document.getElementById("app")
    //console.log("app element",element)

    element.style.height = "100vh"
    element.style.width = "100vw"

    // set the background for the page

     // https://ionicframework.com/docs/theming/dark-mode
    // get the system value for darkmode
    // Use matchMedia to check the user preference

    // Add or remove the "dark" class on the document body
    const toggleDarkTheme = (shouldAdd) => {

      var darkString = "light"
      // set by the preferences. could be to use the system or force light/dark
      if (shouldAdd) {
        const darkBoardColors = connectionStore.getDarkBoardColors
        if (darkBoardColors != null) {
          if (darkBoardColors == "chessvis" || darkBoardColors == "lichess")
            darkString = darkBoardColors   
          else
            darkString = "dark"
        }
        else
          darkString = "dark"
      }

      document.body.classList.toggle('dark', shouldAdd);
      connectionStore.setDarkMode(darkString )
    };

    //console.log("before dark theme")
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    toggleDarkTheme(prefersDark.matches);

    //console.log("before add change")
    // Listen for changes to the prefers-color-scheme media query
    prefersDark.addEventListener('change', 
                  (mediaQuery) => toggleDarkTheme(mediaQuery.matches));

    //console.log("**** BEFORE initvosk")
    var startOnLandingPage = connectionStore.getStartOnLandingPage
    const runRequestFromLandingPage = connectionStore.getRunRequestFromLandingPage

    // TESTING -- force the start on landing page
    //startOnLandingPage = "yes"
    console.log("start on landing page",startOnLandingPage,runRequestFromLandingPage)

    // if from chessvis, android or ios, the cookie and dummy are passed
    if (urlAction == "landing" || urlAction == "play" || 
            urlAction == "android" || urlAction == "ios") {
      const url_c = localStorage.getItem("url_c")
      const url_d = localStorage.getItem("url_d")
      if (url_c != null && url_d != null) {
        const c = decodeURIComponent(url_c)
        const d = decodeURIComponent(url_d)
        connectionStore.setUserCookieDummy(c,d)            
      }
      if (urlAction == "play" || urlAction == "android" || urlAction == "ios")
        startOnLandingPage = "no"
    }
    
    // once a user plays a game, the "startOn..." flag is set to "no"
    // and the user will start within the program
    // if they haven't played before BUT have come here by wanting to play on the landing page,
    //     then "runrequest..." will be yes
    // there are also two URL actions:  play & landing
    if (urlAction == "landing" || (startOnLandingPage == "yes" && runRequestFromLandingPage != "yes")) {
        showState.value = SHOW_NEW_LANDING_PAGE
    }
    else {
      connectionStore.setRunRequestFromLandingPage("no")
      createAudioContext()
      getAudioPermissions()
      //initVosk()
    }
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', onResizeChange)
    if (wakeLock != null)
      wakeLock.release();
  });

  onUnmounted(() => {
 
  })
  

</script>

<style>

.audio-player {
  background-color: red;
  width: 100px;
  height: 100px;
  display: inline-block;
  /* object-fit: cover; */
}

ion-app {
  --ion-safe-area-top: env(safe-area-inset-top);
}

.middle-area {
  position: absolute;
  overflow-y: scroll;
  top: calc(56px + env(safe-area-inset-top));
  left: var(--left-indent);
  width: var(--content-width);
  height: calc(100vh - 56px - env(safe-area-inset-top) - 50px - 1px);
}

.rotated-text {
  transform: rotate(180deg);
  transform-box: fill-box;
  transform-origin: center;
}

</style>
